import { t } from "@/i18n-js/instance";
import { EditorCollapsable } from "@circle-react-shared/BuilderUI/Editor/EditorCollapsable";
import { BoxModelInput } from "@circle-react-shared/Emails/VisualEmailBuilder/EditorFields/BoxModelField/BoxModelInput";
import { ButtonTypePicker } from "@circle-react-shared/Emails/VisualEmailBuilder/EditorFields/ButtonTypePicker";
import { Alignment } from "./Alignment";
import { Background } from "./Background";
import { Borders } from "./Borders";
import { Corners } from "./Corners";
import { Sizing } from "./Sizing";
import { Text } from "./Text";

export const generateFormItemName = (name: string) => {
  const nameParts = name.split(".");
  return ["styles", ...nameParts].join(".");
};

export const StylesEditor = () => (
  <div>
    <EditorCollapsable
      title={t("builder_ui.prop_type.styles.type")}
      defaultOpen
    >
      <div className="px-6 pb-4 pt-3">
        <ButtonTypePicker label={t("builder_ui.prop_type.styles.type")} />
      </div>
    </EditorCollapsable>

    <Sizing />
    <Alignment />

    <EditorCollapsable
      title={t("builder_ui.prop_type.styles.padding")}
      defaultOpen
    >
      <div className="flex flex-col px-6 py-4">
        <BoxModelInput
          type="padding"
          name="styles.padding"
          label={t("builder_ui.prop_type.styles.padding")}
        />
      </div>
    </EditorCollapsable>

    <EditorCollapsable
      title={t("builder_ui.prop_type.styles.margin")}
      defaultOpen
    >
      <div className="flex flex-col px-6 py-4">
        <BoxModelInput
          type="margin"
          name="styles.margin"
          label={t("builder_ui.prop_type.styles.margin")}
        />
      </div>
    </EditorCollapsable>

    <Background />
    <Borders />
    <Corners />
    <Text />
  </div>
);
